/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import { createApp } from 'vue';
import Bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';

const bugsnagClient = Bugsnag.start({
    apiKey: '2e9504c3103fd9ac6c1a44bf4846a3b1',
    appVersion: __APP_VERSION__,
    plugins: [new bugsnagVue()]
});

const app = createApp({});

app.use(bugsnagClient.getPlugin('vue'));

window.vueApp = app;
